import gql from 'graphql-tag';
import fragments from '../fragments.js';

export default {
    myProfile: gql`
        query MyProfile {
            myProfile {
                ...ProfileFragment
            }
            myEnvironment {
                isBusinessTier
                isEnterpriseTier
                postQuota
                postCountInCurrentPeriod
                customDomain
                planName
            }
            myProfiles {
                ...ProfileFragment
            }
        }
        ${fragments.profile}
        ${fragments.image}
    `,
};
